module.exports = __webpack_public_path__ + "static/media/11import-25.c5ba3edf.xlsx";